export const getPlanUrl = () => 'billing/plan'

export const getBillingPortalUrl = () => 'billing/portal'

export const getBillingProductsnUrl = () => 'billing/products'

export const getBillingSubscriptionSetupUrl = () => 'billing/subscription/setup'

export const getBillingSubscriptionSubscribeUrl = () => 'billing/subscription/subscribe'

export const deletePlanUrl = () => 'billing/plan'

export const upgradeTrialPlanUrl = () => 'billing/upgrade-trial'

export const extendTrialUrl = () => 'billing/extend-trial'

export const pausePlanUrl = () => 'billing/pause'

export const checkBillingUrl = () => 'billing/check'

export const getBillingCheckUrl = () => 'billing/check'
